export default __webpack_public_path__ + "static/media/a012-1.5e5a0774.svg";